/**
 * Test IDs for the Operator page and all its sub-components.
 *
 * Naming convention:  {page}-{section}-{element}-{qualifier?}
 * All IDs are kebab-case and stable — do NOT use display labels or i18n strings.
 *
 * Usage:
 *   import { OPERATOR_TEST_IDS as TID } from "@/constant/testIds/operator.testIds";
 */

export const OPERATOR_TEST_IDS = {
  // ── Page shell ────────────────────────────────────────────────────────────
  PAGE: 'operator-page',

  // ── Toolbar ───────────────────────────────────────────────────────────────
  SEARCH_INPUT: 'operator-search-input',
  ADD_BTN: 'operator-add-btn',
  FILTER_DROPDOWN: 'operator-filter-dropdown',
  FILTER_DROPDOWN_PROVIDER: 'operator-filter-dropdown-provider',
  SUBAPP_SELECT: 'operator-subapp-select',
  STATUS_FILTER: 'operator-status-filter',

  // ── Table ─────────────────────────────────────────────────────────────────
  TABLE: 'operator-table',
  TABLE_ROW: (id: string) => `operator-table-row-${id}`,

  // ── Column cells (per-row, keyed by operatorId) ───────────────────────────
  COL_SOURCE_ID: (id: string) => `operator-col-source-id-${id}`,
  COL_NAME: (id: string) => `operator-col-name-${id}`,
  COL_SUBAPP: (id: string) => `operator-col-subapp-${id}`,
  COL_PROVIDER: (id: string) => `operator-col-provider-${id}`,
  COL_UUID: (id: string) => `operator-col-uuid-${id}`,
  COL_CREATED_ON: (id: string) => `operator-col-created-on-${id}`,
  COL_UPDATED_ON: (id: string) => `operator-col-updated-on-${id}`,
  COL_EDIT_BTN: (id: string) => `operator-col-edit-btn-${id}`,
  COL_DELETE_BTN: (id: string) => `operator-col-delete-btn-${id}`,
  COL_REACTIVATE_BTN: (id: string) => `operator-col-reactivate-btn-${id}`,

  // ── Modals ────────────────────────────────────────────────────────────────
  CREATE_MODAL: 'operator-create-modal',
  EDIT_MODAL: 'operator-edit-modal',
  DELETE_MODAL: 'operator-delete-modal',
  DELETE_CONFIRM_BTN: 'operator-delete-confirm-btn',
  DELETE_CANCEL_BTN: 'operator-delete-cancel-btn',
  // ── CrudOperatorModal form fields ─────────────────────────────────────────
  MODAL_NAME_INPUT: 'operator-modal-name-input',
  MODAL_SOURCE_ID_INPUT: 'operator-modal-source-id-input',
  MODAL_PROVIDER_SELECT: 'operator-modal-provider-select',
  MODAL_SUBAPP_SELECT: 'operator-modal-subapp-select',
  MODAL_CANCEL_BTN: 'operator-modal-cancel-btn',
  MODAL_SAVE_BTN: 'operator-modal-save-btn',
} as const;
